import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function PolarisProviders({ children }: Props) {
  return (
    <AppProvider i18n={enTranslations} features={{ newDesignLanguage: true }}>
      {children}
    </AppProvider>
  );
}
